import { Slider } from "../../components/ui/slider";
import { SelectField } from "../../components/SelectField";
import { ColorField, Panel } from "./fields";

const COLORS = [
  ["primary", "Primary (buttons, highlights)"], ["primary_dark", "Primary hover"], ["primary_light", "Primary tint (selected items)"],
  ["accent", "Accent (gold details)"], ["background", "Page background"], ["surface", "Soft panels & inputs"], ["ink", "Text"],
];

const Preview = () => (
  <div className="rounded-2xl border border-ink/10 bg-sand p-6" data-testid="theme-preview">
    <p className="eyebrow">Live preview</p>
    <h3 className="mt-2 font-serif text-3xl text-ink">Lord's Court Suite</h3>
    <p className="mt-2 text-sm text-ink/70">This is how body text looks with the chosen font and colours.</p>
    <div className="mt-4 rounded-xl bg-linen p-4 text-sm text-ink/70">Soft panel · <span className="text-gold">accent detail</span></div>
    <div className="mt-4 flex flex-wrap gap-3">
      <button type="button" className="btn-primary">Primary</button>
      <button type="button" className="btn-gold">Confirm</button>
      <button type="button" className="btn-outline">Outline</button>
    </div>
  </div>
);

export const ThemeTab = ({ theme, set, fonts }) => {
  const fontOptions = fonts.map((f) => ({ value: f, label: f }));
  return (
    <div className="grid gap-6 xl:grid-cols-[1fr_380px]" data-testid="admin-theme-tab">
      <div className="space-y-6">
        <Panel title="Colours" hint="Changes preview instantly across this page. Click Save to publish.">
          <div className="grid gap-5 md:grid-cols-2">
            {COLORS.map(([k, label]) => (
              <ColorField key={k} label={label} value={theme[k]} onChange={(v) => set({ [k]: v })} testid={`theme-${k.replace("_", "-")}`} />
            ))}
          </div>
        </Panel>
        <Panel title="Typography & shape">
          <div className="grid gap-5 md:grid-cols-2">
            <SelectField label="Heading font" value={theme.heading_font} options={fontOptions} onChange={(v) => set({ heading_font: v })} testid="theme-heading-font" />
            <SelectField label="Body font" value={theme.body_font} options={fontOptions} onChange={(v) => set({ body_font: v })} testid="theme-body-font" />
            <div className="field md:col-span-2">
              <span className="field-label">Corner roundness: {theme.radius}px</span>
              <Slider min={0} max={32} step={2} value={[theme.radius]} onValueChange={([v]) => set({ radius: v })} data-testid="theme-radius-slider" />
            </div>
          </div>
        </Panel>
      </div>
      <div className="xl:sticky xl:top-24 xl:self-start"><Preview /></div>
    </div>
  );
};
